export const bookingDetailsRoute = (orderId = ':orderId') => `/bookings/${orderId}`
